import { invariant } from "@exonn/utils";
import type { CreateVariantRequestParams } from "src/system/types.ts";
import { ResourceEnum } from "src/constants/constants.ts";

type ListState =
  | "dataLoadingEnabled"
  | "refreshIndex"
  | "expandedRows"
  | "state";

type FormState = "lang" | "values" | "uiStore";

export const createResourceStorageKeys = () => {
  return {
    list: ({ resource, state }: { resource: string; state: ListState }) => ({
      name: [resource, "list", state].join("."),
      version: "1",
    }),

    form: ({
      id,
      type,
      state,
      resource,
      tab,
      requestParams,
      meta,
    }: {
      id?: string;
      type: "edit" | "create";
      state: FormState;
      tab?: string;
      resource: string;
      requestParams?: Record<string, any>;
      meta?: any;
    }) => {
      invariant(
        type !== "edit" || !!id,
        "id must be specified for storage key of edit form",
      );

      const variantRequestParams = requestParams as
        | CreateVariantRequestParams
        | undefined;

      if (type === "create" && resource === ResourceEnum.Variant) {
        return {
          name: [
            resource,
            "form",
            state,
            type,
            variantRequestParams?.product_id,
          ].join("."),
          version: "4",
        };
      }

      return {
        name: [resource, "form", state, type, id, tab ?? "general"].join("."),
        version: "4",
      };
    },

    tabs: (resource: string) => ({
      name: [resource, "tabs"].join("."),
      version: "1",
    }),
  };
};
